import React, { useEffect, useState, useMemo } from 'react';
import { IExistingCustomerSearch } from './types'
import Button from '@material-ui/core/Button';
import EditIcon from '@material-ui/icons/Edit';
import PersonAddIcon from '@material-ui/icons/PersonAdd';
import SearchCustomer from 'design-v2/common/SearchCustomer'
import UsersTable from 'design-v2/common/UsersTable';
import Box from '@material-ui/core/Box';
import { SEARCH_FIELDS } from 'app/app.types';
import { ICustomer } from 'shared-types/SharedTypes';
import UtilsService from 'external-services/utils-service';
import { customerViewType } from 'app/customers/customerDetails/types'
import style from './style.module.scss';

const SEARCH_ORDER = [SEARCH_FIELDS.FIRST_NAME, SEARCH_FIELDS.LAST_NAME, SEARCH_FIELDS.PHONE, SEARCH_FIELDS.EMAIL];
export const NOTE_BOOKING_WILL_NOT_SAVE_CUSTOMER = "Note: Otherwise, booking won’t save to a customer record."

export default function ExistingCustomerSearch(props: IExistingCustomerSearch) {
  const { customer, setCustomer, customers, setView, inputOnFocus, errors, setErrors, handleViewCustomer, handleEditCustomer, country, searchResultStatus, view } = props
  const [lastFocusField, setLastFocusField] = useState(SEARCH_FIELDS.FIRST_NAME as string);
  const [customerList, setCustomerList] = useState<ICustomer[]>([]);
  const _inputOnFocus = (field: string) => {
    setLastFocusField(field)
    inputOnFocus(field)
  }

  const isAllowedCreateNewCustomer = useMemo(() => {
    if (customer?.email?.length || customer?.phone?.length) {
      return false
    }
    if (customers?.length && (!customer?.email?.length && !customer?.phone?.length) && (customer?.firstName?.length || customer?.lastName?.length)) {
      return true
    }
    return false
  }, [customer, customers])

  useEffect(() => {
    if (customers?.length > 0) {
      const sortFields = [lastFocusField, ...SEARCH_ORDER.filter(field => field !== lastFocusField)];
      setCustomerList(customers.sort(UtilsService.fieldSorter(sortFields)));
    } else {
      setCustomerList([]);
    }
  }, [lastFocusField, customers]);

  const isShownSearchNote = (customer?.firstName?.length || customer?.lastName?.length) && !customer.phone && !customer.email

  return (
    <Box className={style.root}>
      <Box className={style.searchOnLeft}>
        <SearchCustomer
          country={country}
          customer={customer}
          handleChange={setCustomer}
          inputOnFocus={_inputOnFocus}
          errors={errors}
          setErrors={setErrors}
          view={view}
        />
      </Box>
      <Box className={style.displayFormOnRight}>
        <Box display="flex" flexDirection="column">
          <span className={style.searchMatches}>Search matches</span>
          <span className={style.helperText}>Select or create a customer to continue with your booking.</span>
          {isShownSearchNote ? <span className={style.note}>{NOTE_BOOKING_WILL_NOT_SAVE_CUSTOMER}</span> : null }
        </Box>
        <UsersTable
          customers={customerList}
          handleViewCustomer={handleViewCustomer}
          handleEditCustomer={handleEditCustomer}
          searchResultStatus={searchResultStatus}
          setView={() => setView(customerViewType.NEW_CUSTOMER_VIEW)}
          isAllowedCreateNewCustomer={isAllowedCreateNewCustomer}
        />
        {isAllowedCreateNewCustomer ? <Box mt="16px">
          <p className={style.subTitle}>Can't find the right match?</p>
          <Button variant='outlined' color='primary' onClick={() => setView(customerViewType.NEW_CUSTOMER_VIEW)}>
            <PersonAddIcon color="inherit" />
            <span className={style.createNewCus}>
              Create a new customer
            </span>
          </Button>
        </Box> : null}
      </Box>
    </Box>
  )
}

